module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "component-inline-editable-field",
    attrs: {
      "title": "Double click for edit"
    }
  }, [(_vm.editable) ? _c('div', {
    staticClass: "fa fa-save",
    on: {
      "click": _vm.saveAndClose
    }
  }, [_vm._v(" ")]) : _vm._e(), (_vm.editable) ? _c('div', {
    staticClass: "fa fa-times",
    on: {
      "click": _vm.closeAndRevert
    }
  }) : _vm._e(), _c('div', {
    staticClass: "field",
    class: {
      editable: _vm.editable
    },
    attrs: {
      "contenteditable": _vm.editable
    },
    on: {
      "dblclick": _vm.toggleEdit,
      "input": _vm.update,
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.update($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.item_field))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-db74637a!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/structure/ui/InlineEditableField.vue
// module id = 2721
// module chunks = 1